module.exports = __webpack_public_path__ + "img/theme5Tran.947b55ac.png";